let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3qETa")).then(() => parcelRequire('19vLN'));